import styled from "styled-components"

export const CreateAccountBody = styled.div`
  height: 100%;
  padding: 16px var(--app-horizontal-padding);
  padding-top: 32px;
`

export const CreateAccountTitle = styled.p`
  font-size: 24px;
  font-weight: 800;
  line-height: 120%;
`

export const CreateAccountDescription = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 120%;
  color: var(--White_80, rgba(255, 255, 255, 0.8));
`

export const ConfirmTermText = styled.div`
  font-size: 12px;

  a {
    color: var(--Primary-Color, #2cccd3);
    text-decoration: none;
    font-weight: 700;
  }
`
